import {Icon} from '@iconify/react';
import React, {useRef} from 'react';
import {useTranslation} from 'react-i18next';
import UploadErrorIcon from '../../../assets/icons/UploadError.svg';
import {useFileUpload} from '../hooks/useFileUpload';
import Button from '../../incase-domain/components/button/Button';
import {type TypedTranslation} from '../../i18n';

interface FileUploadProps {
    error?: boolean;
    onChange: (files: FileList) => void;
    descI18n?: TypedTranslation;
    failDescI18n?: TypedTranslation;
    ctaI18n?: TypedTranslation;
}

FileUpload.defaultProps = {
    error: false,
};

function FileUpload(props: FileUploadProps): JSX.Element {
    const {error, onChange, descI18n, ctaI18n, failDescI18n} = props;
    const inputRef = useRef<HTMLInputElement>(null);
    const {t} = useTranslation();

    const {dropHandler, dragOverHandler} = useFileUpload(onChange);

    function getBody(): JSX.Element {
        if (error) {
            return (
                <>
                    <img src={UploadErrorIcon} alt="upload error cloud icon" />
                    <p className="c-fileUpload__title">{t(failDescI18n ?? 'common.uploadFailed')}</p>
                    <p className="c-fileUpload__description">{t(descI18n ?? 'common.dragFiles')}</p>
                </>
            );
        }

        return (
            <>
                <Icon className="c-fileUpload__icon" icon="line-md:upload-loop" />
                <p className="c-fileUpload__title">{t('common.dragFiles')}</p>
            </>
        );
    }

    return (
        <label className={`c-fileUpload ${error ? 'is-error' : ''}`} onDrop={dropHandler} onDragOver={dragOverHandler}>
            <input
                ref={inputRef}
                type="file"
                onChange={(ev: React.ChangeEvent<HTMLInputElement>) => {
                    const {files} = ev.target;
                    if (files) onChange(files);
                }}
            />

            {getBody()}

            <Button variant="solid" size="sm" color="secondary" onClick={() => inputRef.current?.click()}>
                {t(ctaI18n ?? 'common.browseFiles')}
            </Button>
        </label>
    );
}

export default FileUpload;
